import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import ThirdsHero from "."

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokContentThirdsHero = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ThirdsHero>) => {
  const getCtaLink = (link: Storyblok.Link) => storyblokLinkToYocoLink(link)

  return (
    <ThirdsHero
      headingSuperscript={blok.headingSuperscript}
      heading={blok.heading}
      headingSize={blok.headingSize}
      description={blok.description}
      highlightedDescriptionText={blok.highlightedDescriptionText}
      imageUrl={blok.image?.filename}
      imageAlt={blok.image?.alt}
      videoUrl={blok.video?.filename}
      buttons={blok.buttons?.map((button) => ({
        text: button.text,
        link: getCtaLink(button.link),
        imageUrl: button.image?.filename,
        imageAlt: button.image?.alt,
        imageButtonDescription: button.imageButtonDescription,
      }))}
      showTrustedStamp={blok.showTrustedBy}
      backgroundColor={blok.backgroundColor}
      numberCallout={
        blok.numberCallout?.[0]
          ? {
              ...blok.numberCallout[0],
              icon: blok.numberCallout[0].icon?.filename,
            }
          : undefined
      }
      priceBadge={blok.priceBadge?.[0]}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokContentThirdsHero
